export const appGlobals = {
    ashaBrandBlockLongPath: '/assets/img/AALZ-Brand-Block-Color-Long.svg',
    ApiTimeoutInSeconds: 15,
    cacheExpirationInMinutes: 100,
    genericProfilePhotoPath: '/assets/img/generic-profile.webp',
    phoneScreenMaxWidthInPixels: 575,
    uploadFileNameMaxLength: 99,
}